<template>
  <div>
    <card-custom
      class="d-flex flex-column mb-2"
      event_name="pvsystTable"
      :show_dropdown_state="true"
      :dropdown_state="cardMessage.pvsystTable"
      outlined
      elevation="1"
      style="width: 100%;"
    >

      <template v-slot:title>
        <div class="text-subtitle-2">{{ $t("_tableau_de_reconciliation_entre_les_hypotheses_de_dimensionnement_(PVSYST)_et_les_resultats_de_l_analyse_helioflash_") }}  </div>
      </template>

      <template v-slot:content>
        <v-container class="d-flex flex-column px-0 py-0" v-html='$t("_pvsyst_tableau_de_reconciliation_texte_explicatif_")'>
        </v-container>
      </template>
    </card-custom>


    <v-data-table
      :headers="headers_values"
      :items="my_data"
      :items-per-page="-1"
      disable-sort
      group-by="section"
      show-group-by
      class="data-table-pvsyst"
      :item-class ="setTitleRowItem"
      ref = "table_key"
      hide-default-header
      hide-default-footer
      fixed-header
      :footer-props="{
                    'items-per-page-options': [20, 50, 100, -1],
                    'items-per-page-text': this.$t('_lignes_par_page_'),           
                  }"
      height="80vh"
    >
      <template v-slot:header="{ props }">
        <thead class="top">
          <tr>
            <th></th>
            <th colspan="1" class="pvsyst-column">
              {{ $t(headers_group[0])}}
            </th>
            <th colspan="3" class="other-meteo-first-column other-meteo-column other-meteo-last-column">
              {{ $t(headers_group[1])}}
            </th>
            <th colspan="3" class="helio-meteo-column helio-meteo-first-column helio-meteo-last-column" >
              {{ $t(headers_group[2])}}
            </th>
            <th/>
          </tr>
          <tr >
            <th v-for="head in props.headers" :key="head.value" :class="setClass(head)">
              {{ $t(head.text) }}
            </th>
          </tr>
        </thead>
      </template>

      <template v-slot:[`group.header`]="{ group, headers, isOpen, toggle }"/> 

      <template v-slot:[`group.summary`]="{headers, isOpen, toggle, items }">
        <td v-for="item in headers.slice(0,-1)" :key="item.value" :class="setClass(item) + ' ' + isAvailable(getElemToGroupBy(items)[item.value], true )">
          <div v-if="item.value === 'label' && getElemToGroupBy(items)">
            <v-btn v-if="getElemToGroupBy(items)[item.value] !== '_pr_sur_annee_ent_' && getElemToGroupBy(items)[item.value] !== '_pvsyst_pr_sur_annee_ent_'" icon small @click="toggle">
             
              <Icon v-if="isOpen" icon="mdi:arrow-expand-down"></Icon>
              <Icon v-else icon="mdi:arrow-expand-up"></Icon>
       
              
            </v-btn>
            {{ $t(getElemToGroupBy(items)[item.value]) }}
          </div>
          <div  v-else-if="item.value !== 'delta_pvsyst_loss' && getElemToGroupBy(items)"  >
            {{ getElemToGroupBy(items)[item.value] }}
          </div>

        </td>
        <td  v-if='getElemToGroupBy(items)' :class="'result ' + isAvailable(getElemToGroupBy(items)['delta_pvsyst_loss'], true)"  >
          {{ getElemToGroupBy(items)["delta_pvsyst_loss"] }}
        </td>
      </template>

      <template v-slot:[`item.label`]="{ item }">
        <td >
          {{ $t(item.label) }}
        </td>
      </template>

      <template v-slot:[`item.pvsyst`]="{ item }">
          <td :class="'pvsyst-column ' + isAvailable(item.pvsyst)">
            {{ item.pvsyst }}
          </td>
      </template>

      <template v-slot:[`item.pvsyst_act_autre_meteo`]="{ item }">
        <td :class="'other-meteo-first-column ' + isAvailable(item.pvsyst_act_autre_meteo)" >
          {{ item.pvsyst_act_autre_meteo }}
        </td>
      </template>

      <template v-slot:[`item.vs_pvsyst_heliocity_autre_meteo`]="{ item }">
        <td :class="'other-meteo-last-column ' + isAvailable(item.vs_pvsyst_heliocity_autre_meteo)">
          {{ item.vs_pvsyst_heliocity_autre_meteo }}
        </td>
      </template> 

      <template v-slot:[`item.pvsyst_act_heliocity`]="{ item }">
        <td :class="'helio-meteo-first-column ' + isAvailable(item.pvsyst_act_heliocity)">
          {{ item.pvsyst_act_heliocity }}
        </td>
      </template>

      <template v-slot:[`item.vs_pvsyst_heliocity_heliocity`]="{ item }">
        <td :class="'helio-meteo-last-column ' + isAvailable(item.vs_pvsyst_heliocity_heliocity)">
          {{ item.vs_pvsyst_heliocity_heliocity }}
        </td>
      </template>

      <template v-slot:[`item.delta_pvsyst_loss`]="{ item }">
        <td :style="calcRgb(item.delta_pvsyst_loss)" :class="isAvailable(item.delta_pvsyst_loss)">
          {{ item.delta_pvsyst_loss }}
        </td>
      </template>

      <template v-slot:[`item.heliocity_heliocity`]="{ item }">
        <td :class="isAvailable(item.heliocity_heliocity)">
          {{ item.heliocity_heliocity }}
        </td>
      </template>

      <template v-slot:[`item.heliocity_autre_meteo`]="{ item }">
        <td :class="isAvailable(item.heliocity_autre_meteo)">
          {{ item.heliocity_autre_meteo }}
        </td>
      </template>

    </v-data-table>
  </div>
</template>

<script>
import { Icon } from '@iconify/vue2';
import CardCustom from "../UI_kit/CardCustom.vue"
import eventBus from "../../store/event_bus"


export default {
  name: "PvsystInput",
  props: {
    res: Object,
  },

  components: {
    Icon,
    CardCustom
  },

  mounted (){
    eventBus
      .$on(`card_custom`, (obj) => {
        this.cardMessage[obj.component] = obj.state
      })
  },

  beforeDestroy() {
    eventBus.$off(`card_custom`)
  },

  data: function () {
    return {
      data_pvsyst: [],
      cardMessage: {
        "pvsystTable": true,
      },
      table_key: 0,
      ref_value: 0,
      headers_group: [
        "_reference_dimensionnement_",
        "_recalcul_avec_meteo_client_",
        "_calcul_avec_meteo_heliocity"
      ],
      listCalcul : [
        "_irradiation_effective_capteurs_",
        "_energie_champ_nominal_stc_",
        "_energie_champ_virtuelle_mpp_",
        "_energie_estimee_a_la_sortie_onduleur_",
        "_energie_constatee_a_la_sortie_ondueur_",
        "_energie_selon_compteur_EDF_",
        "_pvsyst_pr_sur_annee_ent_",
        "_pr_sur_annee_ent_"
      ],
      listEnergie: [
        "_energie_constatee_a_la_sortie_ondueur_",
        "_energie_selon_compteur_EDF_"
      ],
      otherLosses: [
      "_pertes_chaines_deconnectees_",
      "_pertes_diodes_intermittentes_",
      "_pertes_survieillissement_apparent_courant_",
      "_pertes_survieillissement_apparent_tension_",
      ],
      my_data:[],
      input_data: [],
      result: [],

      headers_values: [
        {
          text: "_variable_",
          value:"label",
          groupable: false,
          cellProps: {
            style: 'text-transform: capitalize',
          },
        },
        {
          text: "_valeur_dimensionnement_pvsyst_",
          value: "pvsyst",
          groupable: false
        },
        {
          text: "_pvsyst_actualise_meteo_client_",
          value: "pvsyst_act_autre_meteo",
          groupable: false
        },
        // {
        //   text: "vs.pvsyst",
        //   value: "vs_pvsyst_act_autre_meteo",
        //   groupable: false
        // },
        {
          text: "_helioflash_actualise_meteo_client_",
          value: "heliocity_autre_meteo",
          groupable: false
        },
        {
          text: "vs.pvsyst",
          value: "vs_pvsyst_heliocity_autre_meteo",
          groupable: false
        },
        {
          text: "_pvsyst_actualise_meteo_heliocity_",
          value: "pvsyst_act_heliocity",
          groupable: false
        },
        // {
        //   text: "vs.pvsyst",
        //   value: "vs_pvsyst_act_heliocity",
        //   groupable: false
        // },
        {
          text: "_helioflash_",
          value: "heliocity_heliocity",
          groupable: false
        },
        {
          text: "vs.pvsyst",
          value: "vs_pvsyst_heliocity_heliocity",
          groupable: false
        },
        {
          text: "_ecart_pvsyst_",
          value: "delta_pvsyst_loss",
          groupable: false
        }
      ]
    };
  },

  watch: {
    res: function () {
      /**
       * When result change, whe get the input and res value to print
       */
      this.input_data = this.$store.getters.inputData;
      this.result = this.res.values.result
      this.computeData()
      this.table_key = this.table_key + 1
    },
  },

  methods: {
    isAvailable(value, isBlack=false){
      if (value === "x" && !isBlack){
        return "disable"
      } else if (value === "x") {
        return "disable-black"
      }
      return ""
    },


    setTitleRowItem(item){
      /**
       * Set row type 
       */
      //console.log(item.label)
      if (this.listCalcul.includes(item.label)) {
        return 'some_text';
      } else if (this.listEnergie.includes(item.label)) {
        return 'energie-value'
      } else if (item.label == "_global_incline_") {
        return 'global-incline'
      } else if (item.label.includes('delta')) {
        return 'delta'
      } else if (this.otherLosses.includes(item.label)) {
        return 'other-losses'
      }
    },

    getElemToGroupBy(groupItems){
      let elem = null
      for (let e in this.listCalcul){
        if (groupItems.find(elem => elem.label === this.listCalcul[e])) {
          elem = groupItems.find(elem => elem.label === this.listCalcul[e])
        }
      }
      return elem
    },
    setClass(item){
      /**
       * set class to create column section
       */
      if (item.value === "pvsyst") {
         return "pvsyst-column"
      }else if ( item.value.includes("autre_meteo")) {
        if (item.value === "pvsyst_act_autre_meteo") {
          return "other-meteo-first-column other-meteo-column"
        }else if(item.value === "vs_pvsyst_heliocity_autre_meteo") {
          return "other-meteo-last-column other-meteo-column"
        } else {
          return "other-meteo-column"
        }
      }else if ( item.value !== "delta_pvsyst_loss" && item.value !== "label" && item.value !== "section") {
        if (item.value === "vs_pvsyst_heliocity_heliocity") {
          return "helio-meteo-column helio-meteo-last-column"
        } else if(item.value === "pvsyst_act_heliocity") {
          return "helio-meteo-column helio-meteo-first-column"
        } else {
          return "helio-meteo-column"
        }
      }
    },

    on_mounted(){
      this.table_key = this.table_key + 1
    },

    extractLabels(label) {
      /**
       * extract labels in data to create table's line
       */
      for (let e in this.$store.getters.constants['pvsyst']){
        for (let i in this.$store.getters.constants['pvsyst'][e]["datas"]) {
          let item = this.$store.getters.constants['pvsyst'][e]["datas"][i]
          if (!(item.section in label)) {
            label[item.section] = []
          }
          for (let h in item.positions) {
            if (!label[item.section].includes(item.positions[h].line )) {
              label[item.section].push(item.positions[h].line)
            }
          }
        }
      }
      return label
    },

    mapData(listElem, check_unit = false) {
      /**
       * Map data in the table in the correct line and column
       */
      for (let e in this.my_data) {
        for (let i in listElem) {
          for (let h in listElem[i].positions) {
            if (listElem[i].positions[h].line === this.my_data[e].label) {
              if((listElem[i].unit && check_unit && listElem[i].unit === "%")){
                this.my_data[e][listElem[i].positions[h].column] = (listElem[i].value*100).toFixed(2) + " " + listElem[i].unit
              } else if (listElem[i].unit) {
                this.my_data[e][listElem[i].positions[h].column] = listElem[i].value  + " " + listElem[i].unit
              } else {
                this.my_data[e][listElem[i].positions[h].column] = listElem[i].value
              }

              if (this.listCalcul.includes(this.my_data[e].label)) {
                this.my_data[e].res = true
              } else {
                this.my_data[e].res = false
              }
            }
          }
        }
      }
    },

    computeData() {
      /**
       * Merge and map all data (input, result and motor values) to print
       */
      let labels = {}
      labels = this.extractLabels(labels)

      this.my_data = []

      for (let e in labels) {
        for (let i in labels[e]) {
          this.my_data.push({
            "label":labels[e][i],
            "dairy": 'Yes',
            "section":e,

            "pvsyst": null,

            "pvsyst_act_autre_meteo": null,
            "heliocity_autre_meteo": null,
            "vs_pvsyst_heliocity_autre_meteo": null,

            "pvsyst_act_heliocity": null,
            "heliocity_heliocity": null,
            "vs_pvsyst_heliocity_heliocity": null,

            "delta_pvsyst_loss": null
          })
        }
      }
      this.mapData(this.input_data, false)
      this.mapData(this.res.motor_values, true)
      this.mapData(this.result, true)

      this.detectVoidCell()
    },

    detectVoidCell(){

      let linesAndColumns = this.listAllLinesAndColumns()
      for (let i in this.my_data){
        for (let e  in this.headers_values){
          let index = linesAndColumns.findIndex(elem => elem.line === this.my_data[i].label && elem.column === this.headers_values[e].value )
          if (index < 0 && this.headers_values[e].value != "label" && this.headers_values[e].value != "section" ){
            this.my_data[i][this.headers_values[e].value] = "x"
          }

        }
      }
    },


  listAllLinesAndColumns() {
    let linesAndColumns = [];

    for (let e in this.$store.getters.constants['pvsyst']) {
      this.$store.getters.constants['pvsyst'][e]["datas"].forEach(item => {
        linesAndColumns = linesAndColumns.concat(item.positions)
    });
    }

    return linesAndColumns;
  
  },

    calcRgb(item){
      /**
       * Create red/green contrast for cell background
       */
      if (typeof(item) == "string") {
        item = item.replace("%","")
      }
      let r
      let g
      let b = 0
      if (item > 0) {
        r = 255
        g = 0
      } else if (item <=0) {
        r = 0
        g = 255 
      }


      return "background : rgb(" + r + ","+ g +"," + b + ",0.5)"
    }
  }
};
</script>

<style scoped>
  /* .result{
    font-weight: bold;
    background-color: white;
  } */

  .v-data-table >>> .some_text{
    display: none;
  }

  .v-data-table >>> tr td {
    border-left: grey 2px solid;
    border-collapse: separate !important;
    text-align: left !important;
  }

  td .pvsyst-column{
    padding: 0px !important;
  }

  th {
    border-left: grey 2px solid ;
    border-collapse: separate !important;
    padding:5px
  }

  .data-table-pvsyst{
    border: grey 2px solid;
    border-collapse: separate !important;
  }

  .other-column td{
    border-left: white 2px solid
  }

  .pvsyst-column{
    border-left: black 5px dashed !important;
    border-right: black 5px dashed !important;
  }

  .top .pvsyst-column{
    border-top: black 5px dashed !important;
  }

  .other-meteo-first-column{
    border-left: blue 5px dashed !important;
  }

  .other-meteo-last-column{
    border-right: blue 5px dashed !important;
  }

  .top .other-meteo-column{
    border-top: blue 5px dashed !important;
  }

  .helio-meteo-first-column{
    border-left: rgb(255, 83, 163) 5px dashed !important;
  }

  .helio-meteo-last-column{
    border-right: rgb(255, 83, 163) 5px dashed !important;
  }

  .top .helio-meteo-column{
    border-top: rgb(255, 83, 163) 5px dashed !important;
  }

  .top-btm {
    display: sticky;
    top: 59px;
    z-index: 2;
    background-color: white; /* Couleur de fond pour s'assurer que le texte est lisible */
  } 

  .top{
    position: sticky;
    top: 0px;
    z-index: 2;
    background-color: white; /* Couleur de fond pour s'assurer que le texte est lisible */
  }

 .top th{
    border-bottom: gray solid 2px;
  }

  .v-data-table >>>  .v-row-group__summary{
    background: rgb(178,178,178) ;
    color: white;
  }

  .v-data-table >>> .v-row-group__summary:hover{
    background-color: rgb(198,198,198) !important;
    color: white;
  }

  .v-data-table >>> .v-row-group__summary td {
    border-left: white 2px solid;
  }

  .v-data-table >>> .global-incline {
    background-color:  rgb(230,230,230);
    color:  black;
    font-weight: bold;

  }

  .v-data-table >>> .delta{
    font-style: italic;
    font-weight: lighter;
   
  }


  .v-data-table >>> .disable{
    background-color: rgb(240,240,240);
    color:rgb(240,240,240);
  }


  .v-data-table >>> .disable-black{
    background-color: rgb(198,198,198);
    color:rgb(198,198,198);
  }

  .v-data-table >>> .other-losses{
    color: rgb(10,10,10) !important;
    font-weight: lighter;
  }

  .v-data-table >>> .other-losses td{
    padding-left:40px
  }



  
</style>
